module.exports = __webpack_public_path__ + "img/b3aab8a.jpg";